import React from "react";
import styled, { css } from "styled-components";

type FormRadioProps = {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  checked: boolean;
};

class FormRadio extends React.PureComponent<FormRadioProps> {
  public render(): JSX.Element {
    const { label, name, value, onChange, checked } = this.props;
    return (
      <RadioLabel htmlFor={value}>
        <Radio
          data-qa={`input.radio.${value}`}
          id={value}
          name={name}
          value={value}
          defaultChecked={checked}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onChange(event.target.value)
          }
        />
        <RadioLabelText>{label}</RadioLabelText>
      </RadioLabel>
    );
  }
}

export default FormRadio;

export const Radio = styled.input.attrs({ type: "radio" })<any>`
  appearance: none;
  z-index: -1;
  position: absolute;
  left: -10px;
  top: -8px;
  display: block;
  margin: 0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  outline: none;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;

  &:active {
    opacity: 1;
    transition: opacity 0s;
  }
`;

export const RadioLabelText = styled.span`
  display: inline-block;
  width: 100%;
  cursor: pointer;

  &:before {
    content: "";
    display: inline-block;
    margin: 2px 10px 2px 0;
    border: solid 5px;
    border-color: ${(props: any) => props.theme.colors.lightGrey};
    background-color: ${(props: any) => props.theme.colors.lightGrey};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    vertical-align: top;
    transition: border-color 0.2s;
  }
`;

export const RadioLabel = styled.label<any>`
  position: relative;
  display: inline-flex;
  height: 30px;
  line-height: 1.5;

  > input:checked + span {
    &:before {
      border-color: ${(props: any) => props.theme.colors.primary};
    }
  }

  > input:active + span:before {
    border-color: ${(props: any) => props.theme.colors.primary};
  }

  > input:disabled + span {
    color: ${(props: any) => props.theme.colors.primary};
    cursor: initial;
  }

  &:hover > input {
    opacity: 0.04;
    &:focus {
      opacity: 0.16;
    }
  }
`;
